// slide03
var paginationText02 = $(".slide_detail_wrap .swiper .pagination_text li");
var slide02 = new Swiper(".slide_detail_wrap .swiper", {
    loop: true,
    slidesPerView: 1,
    navigation: {
        nextEl: '.slide_detail_wrap .swiper .swiper-button-next',
        prevEl: '.slide_detail_wrap .swiper .swiper-button-prev',
    },
    pagination: {
        el: ".slide_detail_wrap .swiper .swiper-pagination",
        clickable: true,
        bulletActiveClass : 'on',
        renderBullet: function (index, className) {
            return '<p class="' + className + '"><span>' + (paginationText02.eq(index).text()) + '</span></p>';
        },
    },
});